'use client';

import { Badge, BadgeProps } from '@chakra-ui/react';

export interface BetaLabelProps extends BadgeProps {
  label?: string;
}

export const BetaLabel = ({ label = 'Beta', ...props }: BetaLabelProps) => {
  return (
    <Badge
      mt={{ mobile: '-6px', desktop: '-4px' }}
      ml={{ mobile: 0, desktop: '-8px' }}
      bg="blackAlpha.800"
      color="white"
      fontSize={{ mobile: '10px', desktop: '12px' }}
      borderRadius="4px"
      px={1.5}
      py={0}
      zIndex="2"
      {...props}
    >
      {label}
    </Badge>
  );
};
